export default __webpack_public_path__ + "static/media/yt-thum-1.bef553d3.jpg";